export var Sorting;
(function (Sorting) {
    Sorting["price"] = "price";
    Sorting["priceASC"] = "priceASC";
    Sorting["priceDESC"] = "priceDESC";
    Sorting["prihotelce"] = "hotel";
    Sorting["flight"] = "flight";
    Sorting["location"] = "location";
    Sorting["outboundDepartureAirport"] = "outboundDepartureAirport";
    Sorting["LOS"] = "LOS";
    Sorting["duration"] = "duration";
    Sorting["durationASC"] = "durationASC";
    Sorting["durationDESC"] = "durationDESC";
    Sorting["categoryASC"] = "categoryASC";
    Sorting["categoryDESC"] = "categoryDESC";
    Sorting["hotelName"] = "hotelName";
    Sorting["hotelRating"] = "hotelRating";
    Sorting["startDate"] = "startDate";
    Sorting["outboundDepartureAirportName"] = "outboundDepartureAirportName";
    Sorting["tourOperatorPriority"] = "tourOperatorPriority";
    Sorting["distance"] = "distance";
})(Sorting || (Sorting = {}));
export default Sorting;
